import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'omni-package-react-core';
import { ArrowForwardIcon } from 'ia-react-core';
import { StyledP, StyledTile, StyledLink, StyledDocumentsTileCol } from './DocumentsTile.styles';
import Constants from '../../Constants';
import useDocumentSummary from '../../hooks/useDocumentSummary';

export interface DocumentsTileProps { }

const DocumentsTile: FC<DocumentsTileProps> = () => {
  const { t } = useTranslation('Documents');
  const { isVisible } = useDocumentSummary();
  if (!isVisible) {
    return null;
  }

  return (
    <StyledDocumentsTileCol xs={12} sm={6}>
      <StyledTile title={t('documentsTile.title')} data-testid="documentsBox" isDivided={false}>
        <StyledP>
          {t('documentsTile.text')}
        </StyledP>
        <StyledLink>
          <Link redirectTo={Constants.BasePagePath} RightIcon={ArrowForwardIcon}>{t('documentsTile.link')}</Link>
        </StyledLink>
      </StyledTile>
    </StyledDocumentsTileCol>
  );
};

export default DocumentsTile;
